<template>
  <div class="__wrapper">
    <div class="__head"></div>
    <div class="__body">
      <div class="__container">
        <div class="__section-center">
          <div class="section-center__layout">
            <!-- <div class="layout__left">
              <div class="__card lesss">
                <div class="contact-card">
                  <div class="section">
                    <router-link to="/profile/consultant">
                      <img :src="$fullUrl('images/profiles/'+user.profile)" />
                    </router-link>
                    <router-link to="/profile/consultant">
                      <h2>{{user.names | validate }}</h2>
                    </router-link>
                    <label>{{user.job | validate }}</label>
                    <span>{{user.location | validate }}</span>
                  </div>
                  <div class="section sec" v-show="user.available_from !== '' ">
                    <label>{{user.available | validate }}</label>
                    <span>{{user.available_from | formatDate | validate }}</span>
                  </div>
                </div>
              </div>
              <div class="__suggestion-box">
                <div class="__body">
                  <div class="vertical">
                    <router-link :to="{name : 'settings', params : {tab : 'terms' | validate }}">
                      <span>Terms & Conditions</span>
                    </router-link>
                    <img src="../assets/icons/stamp.svg" />
                  </div>
                </div>
              </div>
            </div>-->
            <div class="layout__right">
              <search></search>
            </div>
          </div>
        </div>
        <div class="__section-right"></div>
      </div>
      <div class="floater">
        <chat></chat>
      </div>
    </div>
  </div>
</template>
<script>
import Chat from "../components/Chat/Chat";
import Search from "../components/Partials/Search";
import { eventBus } from "../main";
import { mapGetters } from "vuex";
export default {
  components: {
    Chat,
    Search,
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters(["getMeProfile"]),
    userId() {
      return this.getMeProfile.user.id;
    },
    user() {
      let job = "";
      let country = "";
      let city = "";
      if (this.getMeProfile.employment.length > 0)
        job = this.getMeProfile.employment[0].company.name;
      if (this.getMeProfile.profile.location) {
        if (this.getMeProfile.profile.location.country_id)
          country = this.getMeProfile.profile.location.country.name;
        if (this.getMeProfile.profile.location.city_id)
          city = this.getMeProfile.profile.location.city.name;
      }
      return {
        profile: this.getMeProfile.user.profile_picture,
        names:
          this.getMeProfile.user.first_name +
          " " +
          this.getMeProfile.user.last_name,
        email: this.getMeProfile.user.email,
        phone: this.getMeProfile.profile.phone,
        available: "Available from",
        available_from: this.getMeProfile.profile.available_from,
        city: city,
        country: country,
        location: city + (country === "" ? "" : ", " + country),
        job: job,
      };
    },
    notifications() {
      return this.getMeProfile.notifications.map(function (item) {
        eventBus.$set(item, "showOption", false);
        if (item.issuer === null) {
          eventBus.$set(item, "issuer", {});
        }
        return item;
      });
    },
  },

  methods: {},

  watch: {
    $route(to, from) {
      this.$store.dispatch("SEARCH_INDEX", { q: this.$route.params.query });
    },
  },

  created() {
    this.$store.dispatch("GET_ME_PROFILE_DATA");
    this.$store.dispatch("RESET_NOTIFICATION");
    this.$store.dispatch("SEARCH_INDEX", { q: this.$route.params.query });
  },
};
</script>
<style lang="scss" scoped>
.__wrapper {
  background: #efefef;
  min-height: 100%;
  @media (min-width: 300px) and (max-width: 630px) {
    background: #fff;
  }
  .__head {
    height: 90px;
    margin-top: 48px;
    background-image: url("../assets/images/backgrounds/wallpaper.svg");
    background-size: cover;
    @media (min-width: 300px) and (max-width: 630px) {
      display: none;
      margin-top: 48px;
    }
  }
  .__body {
    @media (min-width: 300px) and (max-width: 630px) {
      margin-top: 48px;
    }
    .__container {
      margin: 0 auto;
      width: 800px;
      padding-top: 5px;
      @media (min-width: 300px) and (max-width: 630px) {
        grid-template-columns: 1fr;
        padding-top: 0px;
        width: 100%;
      }
      .__section-center {
        .section-center__layout {
          // display: grid;
          // grid-column-gap: 10px;
          // grid-template-columns: 1fr 4.2fr;
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 1fr;
          }
          .layout__left {
            min-width: 0;
            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }
            h2 {
              color: #535353;
              margin-top: 20px;
              margin-left: 10px;
              font-size: 23px;
            }
            a:hover,
            a {
              text-decoration: none !important;
            }
            .item-row {
              padding: 10px 20px;
              &:hover {
                background: #1890a9;
              }
              img {
                margin-right: 10px;
              }
              span {
                color: #797979;
                font-size: 14px;
                font-weight: normal;
              }
              .fin {
                float: right;
                font-weight: bold;
                margin-top: 2px;
                margin-right: 0 !important;
                font-size: 12px;
              }
            }
            .item-row-active {
              background: #1890a9;
            }
            .__body {
              display: flex;
              flex-direction: column;
              padding: 10px;
              h3 {
                font-size: 14px;
                color: #000000;
                font-weight: bolder;
                text-align: center;
                margin-top: 10px;
                margin-bottom: 30px;
              }
              .__item {
                margin-bottom: 10px;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                padding-left: 20px;
                label {
                  color: #1885ad;
                  font-size: 14px;
                  cursor: pointer;
                  margin-right: 10px;
                  font-weight: normal;
                }
              }
            }
            .contact-card {
              display: flex;
              flex-direction: column;
              .section {
                width: 100%;
                display: flex;
                padding: 10px 0;
                justify-content: center;
                align-items: center;
                border-bottom: 2px solid #f5f5f5;
                flex-direction: column;
                img {
                  width: 60px;
                  height: 60px;
                  cursor: pointer;
                  margin-top: 0px;
                  border-radius: 100%;
                }
                h2 {
                  font-weight: normal;
                  color: #000000 !important;
                  line-height: 20px;
                  text-align: center;
                  margin: 5px 0 !important;
                  font-size: 15px;
                }
                span {
                  color: #4e4e4e;
                  text-align: center;
                  margin-top: 5px;
                  font-size: 14px;
                }
                label {
                  font-size: 14px;
                  text-align: center;
                  margin-top: 10px;
                  color: #808080;
                }
              }
              .sec {
                border-bottom: 0px solid #f5f5f5;
                padding-top: 0;
                span {
                  color: #808080;
                  text-align: center;
                  font-size: 13px;
                }
              }
            }
            .__suggestion-box {
              padding: 10px;
              .__body {
                margin-top: 0px;
                background: transparent;
                .__item {
                  display: flex;
                  margin-bottom: 20px;
                  flex-direction: row;
                  img,
                  .__logo {
                    width: 25px;
                    height: 25px;
                    border-radius: 100%;
                  }
                  .__logo {
                    background: #1885ad;
                    padding: 0 !important;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    span {
                      color: #fff;
                      font-size: 42px;
                      margin: 0 0 12px 12px;
                      font-weight: normal;
                    }
                  }
                  .__centered {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    margin-left: 10px;
                    justify-content: space-between;
                    .__text {
                      display: flex;
                      flex-direction: column;
                      h3 {
                        margin-bottom: 0;
                        font-weight: normal;
                        font-size: 13px;
                        cursor: pointer;
                      }
                      span {
                        margin-top: -5px;
                        font-size: 10px;
                      }
                      .__greyed {
                        color: #000;
                        cursor: default;
                      }
                      label {
                        font-size: 11px;
                      }
                    }
                    img {
                      padding: 5px;
                      border-radius: 100px;
                      width: 20px;
                      height: 20px;
                      background: #ececef;
                    }
                  }
                }
                .vertical {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: center;
                  span {
                    color: #959595;
                    font-size: 10px;
                    text-decoration: underline;
                    cursor: pointer;
                    margin-bottom: 10px;
                    font-weight: normal;
                  }
                  h1 {
                    color: #959595;
                    font-size: 19px;
                    opacity: 0.6;
                    font-weight: normal;
                  }
                  label {
                    font-size: 11px;
                    font-weight: normal;
                    margin-top: 0px;
                    color: #959595;
                  }
                  img {
                    margin-top: 0px;
                  }
                }
              }
            }
          }
          .layout__right {
            min-width: 0;
            .notifications-container {
              span {
                color: #707070;
                &:hover {
                  /*font-weight: lighter;*/
                }
              }
              .__title {
                padding: 5px 10px;
                display: flex;
                justify-content: space-between;
                span {
                  margin: 0 !important;
                  padding: 0 !important;
                  &:hover {
                    font-weight: normal !important;
                  }
                }
                .__grey {
                  color: #707070;
                  cursor: pointer;
                }
              }
              .__body {
                background: #ffffff;
                border-radius: 5px;
                width: 100%;
                .__item {
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                  padding: 10px;
                  border-bottom: 0.5px solid #cbcbcb;
                  font-size: 12px;
                  @media (min-width: 300px) and (max-width: 750px) {
                    flex-direction: column;
                  }
                  .__row {
                    font-size: 12px;
                    display: flex;
                    img {
                      margin-right: 2vh;
                      width: 45px;
                      margin-top: 0.7vh;
                      height: 45px;
                      border-radius: 100%;
                    }
                    .__contents {
                      display: flex;
                      color: #707070;
                      width: 100%;
                      flex-direction: column;
                      h2 {
                        font-family: "Nunito", sans-serif;
                        font-size: 15px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.71;
                        letter-spacing: normal;
                        color: #8b8b8b;
                      }
                      p {
                        margin: 0 0 0.7vh 0;
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        letter-spacing: normal;
                        text-align: left;
                        color: #000000;
                      }
                      a {
                        margin: 0;
                        text-decoration: none;
                        span {
                          color: #1890a9;
                          font-weight: 900;
                        }
                      }
                      span {
                        margin: 0;
                        padding: 0;
                      }
                      .__actions {
                        align-self: flex-end;
                        display: flex;
                        button {
                          padding-left: 15px;
                          padding-right: 15px;
                        }
                        .__yes {
                          background: #1885ad;
                          border-radius: 5px;
                          color: #fff;
                        }
                      }
                      .timelabel {
                        font-family: "Nunito", sans-serif;
                        font-size: 13px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.83;
                        margin-top: -5px;
                        letter-spacing: normal;
                        color: #707070;
                      }
                    }
                  }
                  .options {
                    display: flex;
                    margin-left: 20px;
                    margin-top: 10px;
                    flex-direction: column;
                    button {
                      outline: none;
                      height: 24px;
                      margin-right: 10px;
                      padding: 0 20px;
                      font-size: 1.72vh;
                      border-radius: 5px;
                    }
                    .ok {
                      background: #1ba5a4;
                      color: #fff;
                    }
                    .no {
                      background: transparent;
                      box-shadow: none;
                      color: #707070;
                      margin-top: 10px;
                    }
                  }
                }
              }
              .__footer {
                padding-left: 10px;
                padding-top: 5px;
                padding-bottom: 5px;
                span {
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
    .floater {
      position: fixed;
      bottom: 0px;
      right: 10px;
    }
    .__menus {
      display: none;
      @media (min-width: 300px) and (max-width: 630px) {
        display: grid;
        width: 100%;
        background: #f5f9fc !important;
        position: fixed;
        bottom: 0;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 1px;
      }
      span {
        padding: 10px;
        text-align: center;
        color: #1885ad;
      }
      .__activee {
        background: #1885ad;
        color: #fff;
      }
    }
  }
}
.__card {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
}
.less {
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 10px;
}
.lesss {
  padding: 0 !important;
  border-radius: 5px !important;
  margin-bottom: 10px;
}
</style>
